import React, { useEffect, useRef, useState } from 'react';

const GamaAssistant = ({ active, messages, onToggle, onSendMessage }) => {
  const [inputValue, setInputValue] = useState('');
  const messagesEndRef = useRef(null);
  
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  
  useEffect(() => {
    scrollToBottom();
  }, [messages]);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputValue.trim() === '') return;
    
    onSendMessage(inputValue);
    setInputValue('');
  };
  
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };
  
  return (
    <div className={`gama-assistant ${active ? 'active' : ''}`}>
      <div className="assistant-header" onClick={onToggle}>
        <div className="assistant-avatar">
          <div className="avatar-initials">GA</div>
        </div>
        <div className="assistant-info">
          <h4>Gama Assistente</h4>
          <p>Seu guia de desenvolvimento</p>
        </div>
        <button className="toggle-btn">
          <i className={`fas fa-chevron-${active ? 'down' : 'up'}`}></i>
        </button>
      </div>
      
      <div className="assistant-body">
        <div className="assistant-messages">
          {messages.map((message, index) => (
            <div key={index} className={`message ${message.sender}`}>
              {message.text}
            </div>
          ))}
          <div ref={messagesEndRef} />
        </div>
        
        <form className="assistant-input" onSubmit={handleSubmit}>
          <input
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Pergunte algo ao seu assistente..."
          />
          <button type="submit">
            <i className="fas fa-paper-plane"></i>
          </button>
        </form>
      </div>
    </div>
  );
};

export default GamaAssistant;